import styled from 'styled-components';

export const StatusBlock = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;
  font-size: 12px;
`;

export const StatusMessage = styled.span<{ color: string }>`
  vertical-align: middle;
  color: ${({ color }) => color};
`;

export const StatusIcon = styled.span<{ imgSrc: string }>`
  background-image: url(${({ imgSrc }) => imgSrc});
  background-size: cover;
  background-repeat: no-repeat;
  display: inline-block;
  height: 18px;
  width: 18px;
  margin: 0 2px;
  vertical-align: middle;
`;
